import { useContext } from "react";

import { createError, parseGraphQLError } from "utils";

import { useNotify } from "data/messages/hooks";

import { useAsyncCall, useMutation } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

import { ToasterContext } from "scenes/Hubly/components/Workspace/Provider";

function mutationFactory() {
  const query = `
    mutation changePlan($newCbPlanId: String!, $coupon: String, $applyAtRenewal: Boolean) {
      changePlan(newCbPlanId: $newCbPlanId, coupon: $coupon, applyAtRenewal: $applyAtRenewal) {
        successShortMessage
        successMessage
      }
    }`;

  const resolver = ({ data: { changePlan } }) => {
    return changePlan;
  };

  return { query: query, resolver: createResolverFactory(resolver) };
}

function useChangePlan() {
  const [call, loading] = useAsyncCall();
  const { fireError } = useContext(ToasterContext);
  const changePlan = useMutation(mutationFactory);
  const notifyChangePlanCompleted = useNotify("CHANGE_PLAN_COMPLETED");

  return {
    isProcessing: loading,
    changePlan: async (newCbPlanId, coupon, applyAtRenewal) => {
      return call(async () => {
        try {
          const changePlanResp = await changePlan({
            newCbPlanId,
            coupon,
            applyAtRenewal,
          });
          notifyChangePlanCompleted([true]);

          return changePlanResp;
        } catch (e) {
          const err = createError({
            ...parseGraphQLError(e),
            name: "changePlan",
            defaultMessage:
              "Failed change your plan. Please retry or contact support for assistance",
          });

          fireError(err.message, err);
          return null;
        }
      });
    },
  };
}

export default useChangePlan;
